import { Capacitor } from "@capacitor/core";
import DeviceIDPlugin from "./../../../plugin/DeviceID";
import { Dlog } from "./../../../utils/Dlog";
import env from "./../../../env";

/**
 *
 * @param {*} getSocketFunc This is a socket returned from getSocket() from SocketIOContext
 * @param {*} kioskkey Kiosk Key to login as
 */
export async function loginViaSocket(socket, kioskkey) {
  //Get KioskID
  let kioskID = localStorage.getItem("kioskID");
  Dlog("kioskID from localStorage", kioskID);

  let deviceID = "";
  let serialID = "";

  const deviceIDPluginAvailable = Capacitor.isPluginAvailable("DeviceID");

  if (deviceIDPluginAvailable) {
    const deviceIdValue = await DeviceIDPlugin.get({});
    const serialIdValue = await DeviceIDPlugin.getEloSerial({});

    deviceID = deviceIdValue.androidID;
    serialID = serialIdValue.androidID;
  }

  //Attempt Kiosk Login
  let payload = {
    type: "LOGIN",
    subscriptionID: kioskkey,
    kioskID: kioskID,
    deviceID: deviceID,
    serialID: serialID,
    version: env.REACT_APP_VERSION,
    buildnumber: env.REACT_APP_BUILDNUMBER
  };

  socket.emit("event", payload, () => {
    console.log("customSocketSend SENT SUCCESSFULLLY!");
  });
}

export async function reloginViaSocket(socket, state) {
  //Get KioskID
  let kioskID = localStorage.getItem("kioskID");
  let kioskkey = localStorage.getItem("subscriptionID");

  Dlog("kioskID from localStorage", kioskID);
  Dlog("kioskkey from localStorage", kioskkey);

  let deviceID = "";
  let serialID = "";

  const deviceIDPluginAvailable = Capacitor.isPluginAvailable("DeviceID");

  if (deviceIDPluginAvailable) {
    const deviceIdValue = await DeviceIDPlugin.get({});
    const serialIdValue = await DeviceIDPlugin.getEloSerial({});

    deviceID = deviceIdValue.androidID;
    serialID = serialIdValue.androidID;
  }

  //Attempt Kiosk Login
  let payload = {
    type: "DATAUPDATE",
    subscriptionID: kioskkey,
    kioskID: kioskID,
    deviceID: deviceID,
    serialID: serialID,
    version: env.REACT_APP_VERSION,
    buildnumber: env.REACT_APP_BUILDNUMBER,
    state: state
  };

  //We can't login without a kioskkey
  if (kioskkey !== null) {
    socket.emit("event", payload, () => {
      console.log("customSocketSend SENT SUCCESSFULLLY!");
    });
  }
}

export async function checkLoginCodesViaSocket(socket, kioskkey) {
  //Get KioskID
  let kioskID = localStorage.getItem("kioskID");
  Dlog("kioskID from localStorage", kioskID);

  let deviceID = "";
  let serialID = "";

  const deviceIDPluginAvailable = Capacitor.isPluginAvailable("DeviceID");

  if (deviceIDPluginAvailable) {
    const deviceIdValue = await DeviceIDPlugin.get({});
    const serialIdValue = await DeviceIDPlugin.getEloSerial({});

    deviceID = deviceIdValue.androidID;
    serialID = serialIdValue.androidID;
  }

  //Attempt Kiosk Login
  let payload = {
    type: "CHECK_LOGINCODE",
    subscriptionID: kioskkey,
    kioskID: kioskID,
    deviceID: deviceID,
    serialID: serialID,
    version: env.REACT_APP_VERSION,
    buildnumber: env.REACT_APP_BUILDNUMBER
  };

  socket.emit("event", payload, () => {
    console.log("customSocketSend SENT SUCCESSFULLLY!");
  });
}
